import { Tag, Tooltip, Wrap, WrapItem } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { type ChangedArea, type EventRevisionDto } from "../../../../autogen/bff-api";
import { useChangedAreaLabel } from "./useChangedAreaLabel";

interface Props {
  revision: EventRevisionDto;
  omit?: ChangedArea[];
}

export const ChangedAreaTags = ({ revision, omit = [] }: Props) => {
  const { t } = useTranslation();
  const changedAreaLabel = useChangedAreaLabel();
  const areas = (revision.changedAreas ?? []).filter((area) => !omit.includes(area));

  if (areas.length === 0 && !revision.bidSealWasOpen) return null;

  return (
    <Wrap spacing="1" mt="2">
      {areas.map((area) => (
        <WrapItem key={area}>
          <Tag size="sm" colorScheme="teal" variant="subtle">
            {changedAreaLabel(area)}
          </Tag>
        </WrapItem>
      ))}
      {revision.bidSealWasOpen && (
        <WrapItem>
          <Tooltip label={t("The bids had already been opened to the buyer when this change was started.")}>
            <Tag size="sm" colorScheme="orange" variant="subtle">
              {t("Changed after the bids were opened")}
            </Tag>
          </Tooltip>
        </WrapItem>
      )}
    </Wrap>
  );
};
